import React, { useEffect } from 'react';
import { Icon, IconButton, Loader } from 'rsuite';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import usePrefix from '@/hooks/usePrefix';
import { useRequest } from 'ahooks';
import { fetchLastLevelInfo } from '@/services/account';
import { Level } from '@/constants';
import { FORM_DEFAULT_DISPLAY } from '@/constants/config';

interface LastLevelInfoModalProps {
  /** 客户id */
  memberId: number;
}

export default NiceModal.create(({ memberId }: LastLevelInfoModalProps) => {
  const modal = useModal();
  const { prefix, classname } = usePrefix('bicester-modal');

  const {
    run: getLastLevelInfo,
    data: lastLevelInfo,
    loading: getLastLevelInfoLoading,
  } = useRequest(fetchLastLevelInfo, {
    manual: true,
  });
  useEffect(() => {
    if (modal.visible) {
      getLastLevelInfo(memberId);
    }
  }, [modal.visible]);

  return (
    <>
      <div className={classname}>
        {modal.visible && (
          <div className="w-full h-screen fixed top-0 left-0 bg-black bg-opacity-40 flex justify-center items-center z-[999]">
            <div className="relative flex flex-col items-center p-[40px] bg-[#fff]">
              <IconButton
                icon={<Icon icon="close" />}
                appearance="subtle"
                style={{
                  position: 'absolute',
                  right: 12,
                  top: 12,
                  width: 36,
                  fontSize: 24,
                }}
                onClick={modal.hide}
              />

              <div className="w-[450px] h-[280px] flex items-center">
                {getLastLevelInfoLoading ? (
                  <Loader backdrop vertical content="加载中" />
                ) : (
                  <div className="">
                    <div className="leading-[35px]">
                      最新升级的等级：
                      {Level?.[lastLevelInfo?.upgrade_level] || FORM_DEFAULT_DISPLAY}
                    </div>
                    <div className="leading-[35px]">
                      最新升级的原因：
                      {lastLevelInfo?.upgrade_level_reason || FORM_DEFAULT_DISPLAY}
                    </div>
                    <div className="leading-[35px]">
                      最新升级的等级有效期：
                      {lastLevelInfo?.upgrade_level_validity || FORM_DEFAULT_DISPLAY}
                    </div>
                    <div className="leading-[35px]">
                      最新升级时间：
                      {lastLevelInfo?.upgrade_level_at || FORM_DEFAULT_DISPLAY}
                    </div>
                    <div className="leading-[35px]">
                      最新降级的等级：
                      {Level?.[lastLevelInfo?.down_level] || FORM_DEFAULT_DISPLAY}
                    </div>
                    <div className="leading-[35px]">
                      最新降级的原因：
                      {lastLevelInfo?.down_level_reason || FORM_DEFAULT_DISPLAY}
                    </div>
                    <div className="leading-[35px]">
                      最新降级的等级有效期：
                      {lastLevelInfo?.down_level_validity || FORM_DEFAULT_DISPLAY}
                    </div>
                    <div className="leading-[35px]">
                      最新降级时间：
                      {lastLevelInfo?.down_level_at || FORM_DEFAULT_DISPLAY}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
});
